export function createMultiSelectError(missingTypeName: string, registerMethodName: string) {
   return new Error(
      `<lcs-chip-multi-select> requires a ${missingTypeName}. ` +
         `Please use content projection or the ${registerMethodName} ` +
         `method to register an ${missingTypeName}`
   );
}
